import React, { useEffect } from 'react';
// Corrected import paths: assuming store is one level up from this component's directory
import { useAppDispatch } from '../../store/store'; 
import { setLaunchParams } from '../../store/user/userSlice';

/**
 * Reads URL parameters on initial load and dispatches them to the Redux store.
 * This component should be rendered once high up in the component tree (e.g., in App.tsx).
 */
const UrlParamInitializer: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Check if window is available (client-side context)
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const cId = urlParams.get('cId');
      const sType = urlParams.get('sType');

      // Dispatch the action to save the parameters to the Redux store
      dispatch(setLaunchParams({ 
        cId: cId, 
        sType: sType 
      }));
    }
  }, [dispatch]); // Dependency on dispatch ensures it runs once on mount

  // This component renders nothing, it is purely for side effects.
  return null;
};

export default UrlParamInitializer;
